import { DataType } from '../DataType';
export class TypeProvider {
    // Negative vs. negated conversions
    // TODO: -undefined vs. NOT undefined
    getConvType(dataType) {
        switch (dataType) {
            case DataType.FLOAT:
                return DataType.FLOAT;
            case DataType.STRING:
            case DataType.REGEXP:
            case DataType.NUMBER:
                return DataType.NUMBER;
            case DataType.NULL:
                return DataType.NULL;
            default:
                return DataType.INTEGER;
        }
    }
    getAddType(left, right) {
        if (left === DataType.STRING || right === DataType.STRING) {
            return DataType.STRING;
        }
        else if (left === DataType.REGEXP || right === DataType.REGEXP) {
            return DataType.STRING;
        }
        else if (left === DataType.UNDEFINED || right === DataType.UNDEFINED) {
            return DataType.UNDEFINED;
        }
        switch (left) {
            case DataType.FLOAT:
                return DataType.FLOAT;
            case DataType.NUMBER:
                return DataType.NUMBER;
            default:
                switch (right) {
                    case DataType.FLOAT:
                        return DataType.FLOAT;
                    default:
                        return DataType.INTEGER;
                }
        }
    }
    getMathType(left, right) {
        switch (left) {
            case DataType.STRING:
            case DataType.REGEXP:
                return DataType.NUMBER;
            case DataType.FLOAT:
                return DataType.FLOAT;
            case DataType.NUMBER:
                switch (right) {
                    case DataType.STRING:
                    case DataType.REGEXP:
                        return DataType.STRING;
                    default:
                        return DataType.NUMBER;
                }
            default:
                switch (right) {
                    case DataType.STRING:
                    case DataType.REGEXP:
                        return DataType.NUMBER;
                    case DataType.FLOAT:
                        return DataType.FLOAT;
                    default:
                        return DataType.INTEGER;
                }
        }
    }
    getFieldType(field) {
        return field.dataType;
    }
    getFuncReturnType(func, args) {
        return func.getReturnType(args);
    }
}
